import SVG from "svg.js";
import MobileDetect from './mobile';

class Rent {

    Init = () => {

        var rentDataFloors = Object.keys(rent['floors']).sort(function(x, y) { return sortObject(x, y); });

        const self = this;

        if ($('.rent').hasClass('rent-floors')) {
            var tableHtml = '', listHtml = '';
            $.each(rentDataFloors, function(index, elem) {
                var key = elem;
                var value = rent['floors'][key];
                var count_objects = 0;
                $.each(value['objects'], function(key_objects, value_objects) {
                    var area = value_objects['area'];
                    var type = value_objects['type'];
                    var space = value_objects['size'];
                    if (value_objects['status'] != 0) {
                        count_objects ++;
                        /*$('.rent-filtr input').each(function() {
                            var val = $(this).attr('data-value').split('-');
                            var name = $(this).attr('name');
                            if (parseFloat(area) >= parseInt(val[0]) && parseFloat(area) <= parseInt(val[1])) {
                                space = $(this).attr('data-label');
                            }
                        });*/
                        let type_html = '';
                        if(type) {
                            type_html = (type.toLowerCase().match('retail') !== null ? ' retail' : '');
                        }else{
                            type ='';
                        }
                        var trHtml = '<tr data-id="' + key_objects + '" data-floor="' + key + '" class="' + (count_objects % 2 == 0 ? 'bg' : '') + type_html + '">';

                        if(type){
                            if(type.indexOf("Food&Beverage")!=='-1'){
                                type = type.replace("Food&Beverage", "Food & Beverage");
                            }
                        }


                        trHtml += '<td data-field="num">' + key_objects + '</td>';
                        trHtml += '<td data-field="type">' + type + '</td>';
                        trHtml += '<td data-field="space">' + space + '</td>';
                        trHtml += '<td data-field="area">' + area + '</td>';
                        trHtml += '<td data-field="request"><a href="javascript:void(0)" class="request-lnk"></a></td>';
                        trHtml += '</tr>';
                        tableHtml += trHtml;
                    }
                });
                listHtml += '<a href="javascript:void(0)" class="floor-lnk' + (count_objects == 0 ? ' disabled' : '') + '" data-id="' + key + '">' + key + '</a>';
                if (SVG.supported) {
                }
            });
            $('.rent-data-table tbody').html(tableHtml);
            $('.rent-floors-list').html(listHtml);
            $('.rent-floors-list .floor-lnk').on('click', function() {
                if (!$(this).hasClass('disabled') && !$(this).hasClass('active')) {
                    showFloor($(this).attr('data-id'));
                }
            });
            readHash();
        }
        else {
            var floorUrl = $('.rent').attr('data-floor-url');
            var filterValues = {};
            var filteredData = {};
            var filterInputs = $('.rent-filtr input');
            var filterInputsLen = filterInputs.length;
            var filterCheckedLen = filterInputs.filter(':checked').length;
            filterValues['isAll'] = filterCheckedLen == filterInputsLen || filterCheckedLen == 0;
            filterInputs.each(function() {
                var inp = $(this);
                filterValues[inp.attr('name')] = inp.prop('checked');
                inp.on('change', function() {
                    filterValues[$(this).attr('name')] = $(this).prop('checked');
                    var filterCheckedLen = filterInputs.filter(':checked').length;
                    filterValues['isAll'] = filterCheckedLen == filterInputsLen || filterCheckedLen == 0;
                    filterOffices();
                });
            });

            $('.rent-filtr__tabs a').on('click', function(e) {
                e.preventDefault();
                if (!$(this).hasClass('active')) {
                    $('.rent-filtr__tabs a').removeClass('active');
                    $(this).addClass('active');
                    $('.rent-tab').addClass('hidden').filter('[data-id="' + $(this).attr('href').replace('#', '') + '"]').removeClass('hidden');
                }
                return false;
            });

            var draw, path, path_cur, needToHidePopup, floorTip;
            if (SVG.supported && $('.rent-visual').is(':visible')) {
                draw = SVG('rent-visual__shadow').viewbox('0 0 910 650');
                needToHidePopup = true;
                floorTip = $('.floor-tip');
            }

            var tableHtml = '';
            $.each(rentDataFloors, function(index, elem) {
                var key = elem;
                var value = rent['floors'][key];
                var count_objects = 0;
                let count_objects_desks = 0;
                let count_objects_talks = 0;
                let title_onhover = [];
                filteredData[key] = {};
                $.each(value['objects'], function(key_objects, value_objects) {
                    var area = value_objects['area'];
                    var size_id = value_objects['size_id'];
                    var is_commerce = (key_objects.substr(0, 1) == 'А' || key_objects.substr(0, 1) == 'Б') && value_objects['type_id']!='3';
                    var type = value_objects['type'];

                    var is_talks = (value_objects['type_id']=='3');
                    var is_desks = (size_id=='7');
                    var space = value_objects['size'];;
                    $('.rent-filtr input').each(function() {
                        //var val = $(this).attr('data-value').split('-');
                        var val_size_id = $(this).attr('data-sizeid');
                        var name = $(this).attr('name');
                        //if (parseFloat(area) >= parseInt(val[0]) && parseFloat(area) <= parseInt(val[1])) {
                        if (size_id === val_size_id || (name == 'is_commerce' && is_commerce) || (name == 'is_talks' && is_talks)) {
                            if (typeof(filteredData[key][name]) == 'undefined') {
                                filteredData[key][name] = [];
                            }
                            filteredData[key][name].push(key_objects);
                            //space = $(this).siblings('.label').text();
                        }
                    });

                    let type_html = '';
                    if(type) {
                        if (type.indexOf("Food&Beverage") !== '-1') {
                            type = type.replace("Food&Beverage", "Food & Beverage");
                        }
                        type_html = (type.toLowerCase().match('retail') !== null ? ' retail' : '');
                    }else{
                        type = '';
                    }

                    if (value_objects['status'] != 0) {
                        if(value_objects['type_id'] != 3){
                            count_objects ++;
                        }else{
                            count_objects_talks++;
                        }
                        if (is_desks) {
                            count_objects_desks = '109';
                            count_objects_talks += 4;
                        }

                        var trHtml = '<tr data-id="' + key_objects + '" data-floor="' + key + '" class="' + (count_objects % 2 == 0 ? 'bg' : '') + type_html + '">';
                        trHtml += '<td data-field="num">' + key_objects + '</td>';
                        trHtml += '<td data-field="floor">' + key + '</td>';
                        trHtml += '<td data-field="type">' + type + '</td>';
                        trHtml += '<td data-field="space">' + space + '</td>';
                        trHtml += '<td data-field="area">' + area + '</td>';
                        trHtml += '<td data-field="request"><a href="javascript:void(0)" class="request-lnk"></a></td>';
                        trHtml += '</tr>';
                        tableHtml += trHtml;
                    }
                });

                if (SVG.supported && $('.rent-visual').is(':visible')) {
                    path = draw.path(value['coords']);
                    path.attr('id','floor' + key);
                    path.attr('data-floor', key);
                    path.attr('data-type', value['type']);
                    path.attr('data-objects', count_objects);
                    path.attr('data-all-objects', count_objects);
                    path.attr('data-talks-objects', count_objects_talks);
                    path.attr('data-all-talks-objects', count_objects_talks);
                    path.attr('data-desks-objects', count_objects_desks);
                    path.attr('data-all-desks-objects', count_objects_desks);
                    //if(count_objects==0){
                    //    path.addClass('disabled');
                    //}
                    path.fill(count_objects == 0 ? 'rgba(0,0,0,0.4)' : 'rgba(255,255,255,0)');
                    path.on('mouseover', function() {
                        var path = document.getElementById('floor' + key);
                        if (!$(path).hasClass('unfiltered') && !$(path).hasClass('disabled')) {
                            var pathBBox = path.getBBox();
                            if (key != path_cur) {
                                needToHidePopup = true;
                                floorTip.addClass('hidden');
                            }
                            if (floorTip.hasClass('hidden')) {
                                floorTip.find('.floor-tip__dig').text(path.getAttribute('data-floor'));

                                let all_obj = path.getAttribute('data-objects');
                                let talks_obj = path.getAttribute('data-talks-objects');
                                let desks_obj = path.getAttribute('data-desks-objects');
                                let all_obj_block = $('.tip_retail');
                                let talks_obj_block = $('.tip_talks');
                                let desks_obj_block = $('.tip_desks');
                                all_obj_block.hide();
                                talks_obj_block.hide();
                                desks_obj_block.hide();

                                if(rent.floors[key].free){
                                    var filterInputs = $('.rent-filtr input');
                                    var filterInputsLen = filterInputs.length;
                                    var filterCheckedLen = filterInputs.filter(':checked').length;
                                    var isAll = filterCheckedLen == filterInputsLen || filterCheckedLen == 0;
                                    var isDesks = filterInputs.filter('[data-sizeid="7"]').prop('checked');

                                    if(rent.floors[key].free.indexOf('||') !== -1){
                                        title_onhover = rent.floors[key].free.split('||');
                                    }else{
                                        title_onhover[0] = rent.floors[key].free;
                                    }
                                    if(all_obj){
                                        all_obj_block.show();
                                        floorTip.find('.tip_retail .floor-tip__objects').text(all_obj);
                                        floorTip.find('.tip_retail .floor-tip__title').text(title_onhover[0]);
                                    }

                                    if ((isAll || isDesks) && Number(desks_obj)>0) {
                                        let langEn = $('body').hasClass('lang-en')
                                        desks_obj_block.show();
                                        floorTip.find('.tip_desks .floor-tip__objects').text(desks_obj);
                                        floorTip.find('.tip_desks .floor-tip__title').text(langEn ? 'Working places' : 'Рабочие места');
                                        talks_obj_block.show();
                                        floorTip.find('.tip_talks .floor-tip__objects').text('4');
                                        floorTip.find('.tip_talks .floor-tip__title').text(title_onhover[1]);
                                    } else if (Number(talks_obj)>0) {
                                        if(Number(all_obj) === 0){
                                            all_obj_block.hide();
                                        }
                                        talks_obj_block.show();
                                        floorTip.find('.tip_talks .floor-tip__objects').text(talks_obj);
                                        floorTip.find('.tip_talks .floor-tip__title').text(title_onhover[1]);
                                    }
                                }
                                floorTip.css('top', (pathBBox.y + Math.min((pathBBox.height - floorTip.outerHeight()) * 0.5, 0)) + 'px').toggleClass('retail', $(path).attr('data-type').toLowerCase().match('retail') !== null).removeClass('hidden');
                            }
                            $('.rent-visual path').removeClass('hover').filter('[data-floor=' + key + ']').addClass('hover');
                            needToHidePopup = false;
                        }
                        path_cur = key;
                    }).on('mouseleave', function() {
                        var path = document.getElementById('floor' + key);
                        $(path).removeClass('hover');
                        needToHidePopup = true;
                        setTimeout(function() {
                            if (needToHidePopup) {
                                floorTip.addClass('hidden');
                            }
                        }, 250);
                    }).on('click', function() {
                        var path = document.getElementById('floor' + key);
                        if (!$(path).hasClass('unfiltered') && !$(path).hasClass('disabled')) {
                            document.location = floorUrl + '#' + key;
                        }
                    });
                }
            });
            $('.rent-data-table tbody').html(tableHtml);
            $('.rent-details').trigger('jsp-update');

            if (SVG.supported && $('.rent-visual').is(':visible')) {
                floorTip.on('mouseover', function() {
                    needToHidePopup = false;
                    $('.rent-visual path').removeClass('hover');
                    var path = document.getElementById('floor' + path_cur);
                    if (!$(path).hasClass('unfiltered') && !$(path).hasClass('disabled')) {
                        $(path).addClass('hover');
                    }
                }).on('mouseleave', function() {
                    needToHidePopup = true;
                    setTimeout(function() {
                        if (needToHidePopup) {
                            $('.rent-visual path').removeClass('hover');
                            floorTip.addClass('hidden');
                        }
                    }, 250);
                }).on('click', function() {
                    if (!$(this).hasClass('hidden')) {
                        document.location = floorUrl + '#' + path_cur;
                    }
                });
            }

            $('.quick-facts__item .rent-more').bind('click', function(e) {
                e.stopPropagation();
                if ($(this).attr('data-filter-name')) {
                    var fltr = $('.rent-filtr');
                    var fltr_tab = fltr.find('.rent-filtr__tabs a[href="#details"]');
                    if (!fltr_tab.hasClass('active')) {
                        fltr_tab.click();
                    }
                    fltr.find('.rent-size__item input').prop('checked', false).filter('[name="' + $(this).attr('data-filter-name') + '"]').prop('checked', true).change();
                    $('html, body').animate({scrollTop: $('.rent').closest('section').offset().top - 50 + 'px' }, 500);
                } else if ($(this).attr('data-href')) {
                    window.open($(this).attr('data-href'), '_blank').focus();
                }
                return false;
            });
        }

        $('.rent-data-table thead th').each(function() {
            $(this).css({'width': $(this).outerWidth() + 'px'});
        });
        $('.rent-data-table').closest('[data-scroll]').append('<div class="rent-data-table-fix"><table class="rent-data-table"><thead>' + $('.rent-data-table thead').html() + '</thead></table></div>');

        $('.rent-data-table tbody tr').on('click', function() {
            if (!$(this).hasClass('unfiltered')) {
                showOffice($(this).attr('data-floor'), $(this).attr('data-id'));
            }
        }).find('.request-lnk').on('click', function(e) {
            e.stopPropagation();
            var tr = $(this).closest('tr');
            if (!tr.hasClass('unfiltered')) {
                self.ShowRequest(tr.attr('data-floor'), tr.attr('data-id'));
            }
        });
        $('#office .button').on('click', function() {
            var p = $('#office');
            self.ShowRequest(p.attr('data-floor'), p.attr('data-id'));
        });

        $(window).scroll(function() {
            var scr = $(document).scrollTop();
            var tHead = $('.rent-data-table-fix');
            var tBlock = tHead.closest('[data-scroll]');
            var tPos = tBlock.offset().top;
            var tH = tBlock.outerHeight();
            tHead.toggleClass('fixed', scr >= tPos && scr <= tPos + tH);
        });
        //filterOffices();
        function filterOffices() {
            var trs = $('.rent-details table tbody tr');
            var paths = $('.rent-visual path');
            trs.toggleClass('unfiltered', !filterValues['isAll']);
            $.each(rent['floors'], function(key, value) {
                var isFloorOk = false;
                let counts_array = [];
                counts_array[key] = {};
                counts_array[key].count = 0;
                counts_array[key].count_talks = 0;

                $.each(filteredData[key], function(fkey, fvalue) {
                    if (filterInputs.filter('[name=' + fkey + ']').prop('checked')) {
                        isFloorOk = true;
                        let count = 0, count_talks = 0;
                        $.each(fvalue, function(okey, ovalue) {
                            trs.filter('[data-id="' + ovalue + '"]').removeClass('unfiltered');
                            if(trs.filter('[data-id="' + ovalue + '"]').length){
                                if(fkey === 'is_talks'){
                                    count_talks++;
                                }else{
                                    count++;
                                }
                            }
                        });
                        counts_array[key].count = counts_array[key].count+count;
                        counts_array[key].count_talks = counts_array[key].count_talks+count_talks;
                    }
                });

                if (SVG.supported && $('.rent-visual').is(':visible')) {
                    paths.filter('[data-floor=' + key + ']').attr('data-objects', counts_array[key].count).attr('data-talks-objects', counts_array[key].count_talks);
                    paths.filter('[data-floor=' + key + ']').toggleClass('unfiltered', !filterValues['isAll'] && !isFloorOk);
                    if(!isFloorOk){
                        paths.filter('[data-floor=' + key + ']').attr('data-objects', paths.filter('[data-floor=' + key + ']').attr('data-all-objects'));
                        paths.filter('[data-floor=' + key + ']').attr('data-talks-objects', paths.filter('[data-floor=' + key + ']').attr('data-all-talks-objects'));
                    }
                }

            });
            trs.removeClass('bg').not('.unfiltered').filter(':odd').addClass('bg');
            $('.rent-details').trigger('jsp-update');
        }

        function showOffice(f, o) {
            var p = $('#office');
            var tr = $('.rent-data-table tbody tr[data-floor=' + f + '][data-id="' + o + '"]');
            //var url = '../src/img/rent/floors/' + f + '/';
            var url = rent['floors'][f]['plan'];
            var data = rent['floors'][f]['objects'][o];
            var coords = data['coords'];
            //var id = o.replace('/', '_').replace('-', '_');
            var id = o;
            p.attr({'data-floor': f, 'data-id': o});

            //p.find('.office-num').text(o);
            let text_popup = '';
            if(data.number){
                text_popup = data.number;
            }
            if(data.altnumber){
                text_popup = data.altnumber;
            }
            p.find('.popup__title').html(text_popup);
            //$('#request .popup__title--else').html(p.find('.popup__title').html());
            //$('#request .popup__title--else').html(text_pupop);

            p.find('.office-area').text(tr.find('td[data-field="area"]').text() + ' ' + $('.rent-details .rent-area-unit').eq(0).text());
            p.find('.office-type').text(tr.find('td[data-field="type"]').text());
            p.find('.office-space').text(tr.find('td[data-field="space"]').text());
            p.find('.office-image')
                .css({'background-image': 'url(\'' + (rent['floors'][f]['objects'][o]['plan']) + '\')'})
                .attr('data-coworking', data.size_id == '7');
            p.find('.office-descr').hide();
            if(data.schedule){
                p.find('.office-descr').show().text(data.schedule);
            }
            p.find('[data-for="coworking"]').toggleClass('hidden', data.size_id != '7');

            p.find('.office-floor-image').html('');
            loadSvg(url, function(svgContent, status) {
                if (status == 200) {
                    var p = $('#office');
                    p.find('.office-floor-image').html(svgContent);
                    var svg = p.find('.office-floor-image svg');
                    if (data && typeof(coords) != 'undefined' && coords != '' && svg.find('path[data-id="' + id + '"]').length == 0) {
                        var coordsArr = coords.split(',');
                        var len = coordsArr.length;
                        if (len % 2 == 0) {
                            var d = 'M';
                            for (var p = 0; p < len; p += 2) {
                                d += (p > 0 ? ' L' : '') + ' ' + coordsArr[p] + ' ' + coordsArr[p + 1];
                            }
                            d += ' z';
                            var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                            path.setAttribute('d', d);
                            path.setAttribute('data-id', id);
                            path.setAttribute('class', 'office-area');
                            svg.prepend(path);
                        }
                    }
                    svg.find('.office-area').prependTo(svg).addClass('hidden').filter('[data-id="' + id + '"]').removeClass('hidden');
                }
            });
            setTimeout(function () {
                $('.fancybox-container').css('cursor','default');
            },650);
            $.fancybox.open($('#office'), {
                type: 'inline',
                touch: {
                    vertical: false,
                },
                hideScrollbar: true,
                opts: {
                    animationEffect: 'zoom-in-out',
                    animationDuration: 500
                },
                afterShow: function () {
                    $('.fancybox-container').css('cursor','default');
                }
            });
        }

        function loadSvg(url, callback) {
            if (SVG.supported && url) {
                var ajax = new XMLHttpRequest();
                ajax.open('GET', url, true);
                ajax.send();
                ajax.onload = function(e) {
                    if (typeof(callback) == 'function') {
                        callback(ajax.responseText, ajax.status);
                    }
                }
            }
        }

        function setHash(hash) {
            hash = hash == '' ? '' : '#' + hash;
            if (window.location.hash != hash) {
                try {
                    if (window.history && window.history.pushState) {
                        window.history.pushState({title: $(document).prop('title')}, $(document).prop('title'), hash != '' ? hash : (window.location.pathname + window.location.search));
                    }
                    else {
                        window.location.hash = hash;
                    }
                } catch(err) {
                    console.log('Ошибка: ' + err.message);
                }
            }
        }

        function readHash() {
            var hash = window.location.hash.replace('#', '');
            hash = decodeURIComponent(hash);
            if (hash.length && typeof(rent['floors'][hash]) != 'undefined') {
                showFloor(hash);
            }
            else {
                showFloor($('.rent-floors-list .floor-lnk:first').attr('data-id'));
            }

        }


        if(!MobileDetect.Init()){
            setTimeout(function() {
                $('html, body').animate({scrollTop: $('.rent').closest('section').offset().top - 50 + 'px' }, 500);
            }, 500);
        }



        function sortObject(x, y) {
            if (isNaN(parseInt(x)) && !isNaN(parseInt(y))) {
                return -1;
            }
            else if (!isNaN(parseInt(x)) && isNaN(parseInt(y))) {
                return 1;
            }
            else {
                return x < y ? -1 : x > y ? 1 : 0;
            }
        }

        function showFloor(f) {
            setHash(f);
            $('.rent-floors-list .floor-lnk').removeClass('active').filter('[data-id="' + f + '"]').addClass('active');
            $('.rent-data-table tbody tr').addClass('unfiltered').filter('[data-floor=' + f + ']').removeClass('unfiltered');
            $('.rent-floors-details').trigger('jsp-update');
            var url = rent['floors'][f]['plan'];
            var data = rent['floors'][f]['objects'];
            //let color_class = '';
            //if(f == 'A' || f == 'B'){
            //    color_class = 'office-tip-blue';
           // }
            $('body').append('<div class="office-tip hidden"><div class="office-tip__dig"></div><div><div class="office-tip__type"></div><div class="office-tip__area"></div></div></div>');

            if ($('.rent-floors-image').is(':visible')) {
                $('.rent-floors-image').html('');
                loadSvg(url , function(svgContent, status) {
                    if (status == 200) {
                        var block = $('.rent-floors-image');
                        //block.attr('data-floor', f).html(svgContent + '<div class="office-tip hidden"><div class="office-tip__dig"></div><div><div class="office-tip__type"></div><div class="office-tip__area"></div></div></div>');
                        block.attr('data-floor', f).html(svgContent);
                        var svg = block.find('svg');
                        var vb = svg[0].getAttribute('viewBox').split(' ');
                        block.attr({'data-width': vb[2], 'data-height': vb[3]});
                        if (data) {

                            //console.log(Object.keys(data));
                            svg.find('path[data-id]').each(function() {
                                if(Object.keys(data).indexOf($(this).attr('data-id')) == -1){
                                    $(this).addClass('disabled');
                                }
                            });

                            $.each(data, function(key, value) {
                                //var coords = value['coords'];
                                //var id = key.replace('/', '_').replace('-', '_');
                                var id = key;
                                /*
                                if (typeof(coords) != 'undefined' && coords != '' && svg.find('path[data-id=' + id + ']').length == 0) {
                                    var coordsArr = coords.split(',');
                                    var len = coordsArr.length;
                                    if (len % 2 == 0) {
                                        var d = 'M';
                                        for (var p = 0; p < len; p += 2) {
                                            d += (p > 0 ? ' L' : '') + ' ' + coordsArr[p] + ' ' + coordsArr[p + 1];
                                        }
                                        d += ' z';
                                        var path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                                        path1.setAttribute('d', d);
                                        path1.setAttribute('class', 'office-area');
                                        path1.setAttribute('data-id', id);
                                        svg.prepend(path1);
                                    }
                                }
                                svg.find('.office-area').prependTo(svg);
                                */
                                if (svg.find('path[data-id="' + id + '"]').length) {
                                    //var path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                                    var path2 = svg.find('.office-area[data-id="' + id + '"' +
                                        ']');
                                    //path2.setAttribute('d', svg.find('.office-area[data-id=' + id + ']').attr('d'));
                                    //path2.attr('class', 'office-over');
                                    //path2.setAttribute('data-id', id);
                                    //path2.attr('data-type', value['type'].split(' / ')[0]);
                                    path2.attr('data-type', value['type']);
                                    path2.attr('data-type-id', value['type_id']);
                                    path2.attr('data-area', value['area']);
                                    //svg.append(path2);
                                    if(value['status']!='1'){
                                        path2.addClass('disabled');
                                    }
                                }

                            });

                            var needToHidePopup = true;
                            var officeTip = $('.office-tip');
                            svg.find('.office-area').on('mouseover', function(e) {
                                var path = $(this);
                                var id = path.attr('data-id');
                                var type = path.attr('data-type');
                                var area = path.attr('data-area');
                                //var pathBBox = path.get(0).getBBox();
                                //var r = Math.max(block.attr('data-width') / block.width(), block.attr('data-height') / block.height());
                                //var index_top = 0.25;
                                //var index_left = 0.25;
                                //var index = 0.25;
                                /*
                                if(f == 'A' || f == 'B'){
                                    r = Math.max(block.width()/block.attr('data-width')*0.25, block.height()/block.attr('data-height'));
                                    //index_top = 1.2;
                                    index_left = 1.5;
                                    //index = 0.25;
                                }

                                if(f == 'B'){
                                    r = r*1.4;
                                    index_left = 0.75;
                                }
                                if(f == 'A'){
                                    r = r*1.8;
                                    index_left = 0.75;
                                    //r = r*1.4;
                                }
                                let top_n = $(this).position().top - block.attr('data-height');
                                console.log($(this).offset().top);
                                let pos = $(this).parent().offset();
                                let elem_left = pos.left;
                                let elem_top = pos.top;
                                // положение курсора внутри элемента
                                let Xinner = e.pageX - elem_left;
                                let Yinner = e.pageY - elem_top;
                                console.log("X: " + Xinner + " Y: " + Yinner);
                                */

                                path.addClass('active');
                                if (id != block.attr('data-cur')) {
                                    needToHidePopup = true;
                                    officeTip.addClass('hidden');
                                }
                                if (officeTip.hasClass('hidden')) {
                                    officeTip.find('.office-tip__dig').text(id);
                                    if(!type){
                                        type = '';
                                    }
                                    officeTip.find('.office-tip__type').text(type);
                                    officeTip.find('.office-tip__area').text(area + ' ' + $('.rent-floors-details .rent-area-unit').eq(0).text());
                                    //officeTip.css({'top': ((pathBBox.y + pathBBox.height * index_top) * r - officeTip.outerHeight()) + 'px', 'left': ((pathBBox.x + pathBBox.width * index_left) * r - officeTip.outerWidth()) + 'px'}).toggleClass('retail', type.toLowerCase().match('retail') !== null).removeClass('hidden');
                                    //officeTip.toggleClass('retail', type.toLowerCase().match('retail') !== null).removeClass('hidden');
                                    officeTip.removeClass('hidden');
                                    //officeTip.css({'top': pathBBox.y-officeTip.outerHeight() + 'px', 'left': pathBBox.x+pathBBox.width + 'px'});
                                    officeTip.css({'top': $(this).offset().top-officeTip.outerHeight() + 'px', 'left': $(this).offset().left + 'px'});
                                }
                                needToHidePopup = false;
                                block.attr('data-cur', id);
                            }).on('mouseleave', function() {
                                $(this).removeClass('active');
                                needToHidePopup = true;
                                setTimeout(function() {
                                    if (needToHidePopup) {
                                        officeTip.addClass('hidden');
                                    }
                                }, 250);
                            }).on('click', function() {
                                showOffice(block.attr('data-floor'), $(this).attr('data-id'));
                            });

                            officeTip.on('mouseover', function() {
                                needToHidePopup = false;
                            }).on('mouseleave', function() {
                                needToHidePopup = true;
                                setTimeout(function() {
                                    if (needToHidePopup) {
                                        officeTip.addClass('hidden');
                                    }
                                }, 250);
                            }).on('click', function() {
                                showOffice(block.attr('data-floor'), block.attr('data-cur'));
                            });
                        }
                    }
                });
            }
        }

    };

    ShowRequest = (f, o) => {
        var p = $('#request');
        var floors =  new Array('1','2','3','4','5','6','7','8','9');
        var data = rent['floors'][f]['objects'][o];
        if (data.size_id == '7') {
            p = $('#request_cowirking');
        } else if (floors.indexOf(f) == -1) {
            p = $('#request_ab');
        }
        p.find('input[name="floor"]').val(f);
        p.find('input[name="office"]').val(o);
        p.attr({'data-floor': f, 'data-office': o});
        let text_popup = '';
        if(data.number){
            text_popup = data.number;
        }
        if(data.altnumber){
            text_popup = data.altnumber;
        }
        if(data.type_id == '3'){
            p.find('.input.date, .input.time').css('display','block');
        }else{
            p.find('.input.date, .input.time').hide();
        }
        p.find('.popup__title--else').html(text_popup);
        $.fancybox.open(p, {
            type: 'inline',
            touch: {
                vertical: false,
            },
            hideScrollbar: true,
            opts: {
                animationEffect: 'zoom-in-out',
                animationDuration: 500,
            }
        });
    }

}

const rent_element = document.querySelector('.rent');
let rent_class = new Rent;
window.ShowRequest = rent_class.ShowRequest;
if(rent_element){
    rent_class.Init();
}

//export default new Rent;